import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ProgramDto, ProgramFundingListItemDto, PlanData, RetailerLookupDto, StrategicBusinessInitiativeLookupDto, BrandLookupDto, BudgetYearLookupDto, SaveProgramCommand, ProgramId } from 'app/client-core/dtos/programs.model';
import { RetailerService } from 'app/client-core/services/retailer.service';
import { ProgramService } from 'app/client-core/services/program.service';
import { Observable } from 'rxjs';
import { ValidationMessage } from 'app/validation';
import { TypeaheadMatch } from 'ngx-bootstrap';
import { ApiResponse } from 'app/client-core/api-response-models';
import { Router } from '@angular/router';
import { BudgetYearTypeaheadComponent, StrategicBusinessInitiativesTypeaheadComponent, RetailersTypeaheadComponent } from '../typeahead';
import { BasicTypeaheadComponent } from '../typeahead/typeaheads/tactics/basic-typeahead.component';
import { CampaignThemeDto } from 'app/client-core/dtos/campaigns.model';
import { CampaignService } from 'app/client-core/services/campaign.service';
import { LayoutService } from '../layout/layout.service';
import { UserService } from 'app/client-core/services/user.service';
import { BrandService } from 'app/client-core/services/brand.service';
import { JobsToBeDoneModel } from 'app/client-core/dtos/jobs-to-be-done.model';
import { NotificationService } from '../utils/notification.service';

@Component({
  selector: 'app-jobs-to-be-done',
  templateUrl: './jobs-to-be-done.component.html',
  styleUrls: ['./jobs-to-be-done.component.scss']
})
export class JobsToBeDoneComponent implements OnInit, OnChanges {
  @Input() brandId: number;
  @Input() title: string;
  jobs: JobsToBeDoneModel[] = [];
  ready = false;
  model: JobsToBeDoneModel = {} as JobsToBeDoneModel;
  validationMessages: ValidationMessage;
  submitted: boolean;

  constructor(
    private layoutService: LayoutService,
    private brandsService: BrandService,private notificationService: NotificationService
  ) {
  }

  getJobs() {
    this.brandsService.getJobsToBeDone(this.brandId).subscribe(data => {
      this.jobs = data.data;
      this.ready = true;
    });
  }

  openDetails(id) {
    const model = this.jobs.find(j => j.active && j.id == id);
    if (model) {
      model.active = false;
      model.canEditDescription = false;
      model.canEditName = false;
      return;
    }
    this.jobs = this.jobs.map(j => {
      const activeJob = j.id == id;
      return {
        ...j,
        active: activeJob,
        canEditDescription: activeJob,
        canEditName: activeJob
      }
    })
  }

  save(job?: JobsToBeDoneModel) {
    this.submitted = false;
    if (!this.canSubmitNew()) {
      this.submitted = true;
      this.validationMessages = new ValidationMessage(null, true, `There were some validation errors.`).isDanger();
      return;
    }
    
    let model = this.jobs.find(j => j.active);
    if (job) {
      model = job;
    }

    if (!model) {
      return;
    }

    model.brandId = this.brandId;
    this.brandsService.saveJobsToBeDone(model).subscribe(data => {
      this.getJobs();
      if (job) {
        this.model = new JobsToBeDoneModel();
      }
      this.validationMessages = new ValidationMessage(null, true, `Job ${job ? 'Added' : 'Saved'}`).isSuccess();
      // this.closeModal();
      
    });
  }

  delete(job) {
    if(job.canDelete != 'DELETE') {
      return;
    }
    this.notificationService.smartMessageBox({
      title: "This job will be permanently deleted. Are you sure you want to delete this Job?",
      content: "",
      buttons: '[No][Yes]'

  }, (ButtonPressed) => {
      if (ButtonPressed == "Yes") {
        this.brandsService.deleteJobsToBeDone(job.id).subscribe(() => {
          this.getJobs();
          this.validationMessages = new ValidationMessage(null, true, `JobDeleted`).isSuccess();
        })
      }
  });
    
  }

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getJobs();
  }

  clear() {

  }

  closeModal() {
    this.layoutService.showSideModal
    this.layoutService.hideSideModal.next();
  }

  cancel() {
    this.jobs = this.jobs.map(j => {
      return {
        ...j,
        active: false,
        canEditDescription: false,
        canEditName: false
      }
    });
    this.closeModal();
  }

  canEditActiveJob() {
    const model = this.jobs.find(j => j.active);
    if (!model) 
      return false;

    if (model.canEdit != "EDIT") 
      return false;

    return true;
  }

  canSubmitNew() {
    return this.isNameValid() && this.isDescriptionValid();
  }

  isNameValid() {
    if (this.model && this.model.name) {
      return true;
    }

    return false;
  }

  isDescriptionValid() {
    if (this.model && this.model.description) {
      return true;
    }

    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/jobs-to-be-done/jobs-to-be-done.component.ts